import Vue from 'vue'
import vueTouch from 'vue-touch';
// import 'es6-promise/auto'
import {createApp} from './main'

// 埋点统计的Class
import Stat from '@public/lib/stat/Stat';
import {getPlatform} from '@/frontend-lib/tools/getPlatform';
import qs from 'qs';

// import VConsole from 'vconsole'
// new VConsole();
Vue.prototype.platform = getPlatform()
// 配置TRACKER，用于触发埋点的对象
// 全局绑定tracker对象
window.myTracker = Vue.prototype.$tracker = new Stat({
    globalParams: {channelId: qs.parse(location.hash.split('?')[1]).channelId || 513}
});
// 全局的从APP获取登录信息的方法
window.getLogInParamsForTestPromise = new Promise(resolve => window.appLogInResolve = resolve);
window.getLogInParamsForTest = function (userData) {
    console.log('---客户端登陆完成---', JSON.parse(userData));
    // getLogInParamsForTestPromise.resolve(userData)
    window.appLogInResolve(JSON.parse(userData));
};

Vue.use(vueTouch, {name: 'v-touch'});

// a global mixin that calls `asyncData` when a route component's params change
Vue.mixin({
    beforeRouteUpdate(to, from, next) {
        const {asyncData} = this.$options
        if (asyncData) {
            asyncData({
                store: this.$store,
                route: to
            }).then(next).catch(next)
        } else {
            next()
        }
    },

    beforeMount() {
        const {asyncData, _storeModuleName, _getStoreModule} = this.$options;
        var hasServerData;
        const that = this;
        if (asyncData) {
            if (_storeModuleName) {
                // 判断是否已有服务端提供的数据（window.__INITIAL_STATE__）
                // 由于组件destroyed的时候已经注销模块，那如果组件beforeMount时，
                // 且在注册模块前能访问到模块数据，说明数据是__INITIAL_STATE__的。
                hasServerData = !!this.$store.state[_storeModuleName];

                // @todo 兼容热替换
                store.registerModule(_storeModuleName, _getStoreModule(), {preserveState: hasServerData});

                // 如果有从服务端获取到的数据，则不需要调用asyncData再次获取数据
                if (hasServerData) {
                    return this.dataPromise = Promise.resolve();
                }
            }

            // 将获取数据操作分配给 promise
            // 以便在组件中，我们可以在数据准备就绪后
            // 通过运行 `this.dataPromise.then(...)` 来执行其他任务
            that.dataPromise = asyncData({
                store: this.$store,
                route: this.$route
            });

        }
    },
    destroyed() {
        const {_storeModuleName} = this.$options;
        // _storeModuleName && this.$store.unregisterModule(_storeModuleName);
    }
})

const {app, router, store} = createApp()

// prime the store with server-initialized state.
// the state is determined during SSR and inlined in the page markup.
if (window.__INITIAL_STATE__) {
    store.replaceState(window.__INITIAL_STATE__)
}

// wait until router has resolved all async before hooks
// and async components...
router.onReady(() => {
    // Add router hook for handling asyncData.
    // Doing it after initial route is resolved so that we don't double-fetch
    // the data that we already have. Using router.beforeResolve() so that all
    // async components are resolved.
    // router.beforeResolve((to, from, next) => {
    //   const matched = router.getMatchedComponents(to)
    //   const prevMatched = router.getMatchedComponents(from)
    //   let diffed = false
    //   const activated = matched.filter((c, i) => {
    //     return diffed || (diffed = (prevMatched[i] !== c))
    //   })
    //   const asyncDataHooks = activated.map(c => c.asyncData).filter(_ => _)
    //   if (!asyncDataHooks.length) {
    //     return next()
    //   }

    //   Promise.all(asyncDataHooks.map(hook => hook({ store, route: to })))
    //     .then(() => {
    //       next()
    //     })
    //     .catch(next)
    // })

    // actually mount to DOM
    app.$mount('#app')
})

// service worker
// if ('https:' === location.protocol && navigator.serviceWorker) {
//   navigator.serviceWorker.register('/service-worker.js')
// }



// WEBPACK FOOTER //
// ./src/entry-client.js